import { readCopy } from '@/i18n/useCopy'
import { useProfileStore } from '@/store/profileStore'
import type { Greeting, Rotate } from './greeting'
import { selectGreeting } from './greeting'
import { readGreetingMemory } from './memory'

/**
 * The greeting for this device, right now.
 *
 * The one impure file in this directory, and it is separate so that
 * `selectGreeting` can stay a function of its arguments. Everything it gathers
 * is already on the device: the profile store reads from local storage at
 * import time, the greeting memory is a synchronous read, and the copy is a
 * plain object. Nothing here can suspend, which is the requirement, because
 * this runs between the tap and the first word.
 */
export function currentGreeting(rotate?: Rotate, now: number = Date.now()): Greeting {
  const memory = readGreetingMemory()
  const profile = useProfileStore.getState()

  return selectGreeting({
    copy: readCopy(),
    now,
    name: profile.displayName(),
    lastSpokeAt: memory.lastSpokeAt,
    topic: memory.topic,
    /*
     * Read here, at the moment the line would be spoken, rather than trusted
     * from whenever the topic was written. Somebody who turns consent off in
     * settings between two conversations has withdrawn permission for the
     * sentence Namu is about to say, and the stored topic is still on the disk
     * until the next write clears it.
     */
    consented: profile.hasConsent(),
    rotate,
  })
}
